const { default: styled } = require("styled-components");

const CardButton = styled.button`
    min-height: 190px;
    width: 100%;
    text-align: left;
    background: #FFFFFF;
    padding: 16px 25px;
    box-sizing: border-box;
    border: 1px solid #DADDE1;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.04);
    border-radius: 8px;
    ${props => !props.active ? `
        border: 1px solid #DADDE1;
    ` : `
        border: 1px solid #3B3B47;
    `}
    &:hover {
        border: 1px solid #3B3B47;
    }
    &:focus {
        outline: none;
    }

`

export default CardButton;